export default {
    formId: 'planesForm',
    formField: {
        name: {
            name: 'name',
            label: 'Nombre del Plan *',
            requiredErrorMsg: 'El nombre del plan es requerido.'
        },
        description: {
            name: 'description',
            label: 'Descripción *',
            requiredErrorMsg: 'La descripción es requerida.'
        },
        monthlyPrice: {
            name: 'monthlyPrice',
            label: 'Precio Mensual *',
            requiredErrorMsg: 'El precio mensual es requerido.'
        },
        currency: {
            name: 'currency',
            label: 'Moneda *',
            requiredErrorMsg: 'La moneda es requerida.'
        },
        monthlyCredits: {
            name: 'monthlyCredits',
            label: 'Créditos Mensuales *',
            requiredErrorMsg: 'Los créditos mensuales son requeridos.'
        },
        durationDays: {
            name: 'durationDays',
            label: 'Duración (Días) *',
            requiredErrorMsg: 'La duración en días es requerida.'
        },
        maxRequestsDay: {
            name: 'maxRequestsDay',
            label: 'Peticiones por día *',
            requiredErrorMsg: 'Las peticiones por día son requeridas.'
        },
        maxRequestsMonth: {
            name: 'maxRequestsMonth',
            label: 'Peticiones por mes *',
            requiredErrorMsg: 'Las peticiones por mes son requeridas.'
        },
        maxAssistants: {
            name: 'maxAssistants',
            label: 'Asistentes máximos *',
            requiredErrorMsg: 'Asistentes máximos requeridos.'
        },
        maxAgents: {
            name: 'maxAgents',
            label: 'Agentes máximos *',
            requiredErrorMsg: 'Agentes máximos requeridos.'
        },
        maxUsers: {
            name: 'maxUsers',
            label: 'Usuarios máximos *',
            requiredErrorMsg: 'Usuarios máximos requeridos.'
        },
        allowChat: {
            name: 'allowChat',
            label: 'Permitir Chat'
        },
        allowImages: {
            name: 'allowImages',
            label: 'Permitir Imágenes'
        },
        allowAudio: {
            name: 'allowAudio',
            label: 'Permitir Audio'
        },
        allowDocuments: {
            name: 'allowDocuments',
            label: 'Permitir Documentos'
        },
        allowEmbeddings: {
            name: 'allowEmbeddings',
            label: 'Permitir Embeddings'
        },
        allowMemory: {
            name: 'allowMemory',
            label: 'Permitir Memoria'
        },
        allowTools: {
            name: 'allowTools',
            label: 'Permitir Herramientas'
        },
        allowRag: {
            name: 'allowRag',
            label: 'Permitir RAG'
        },
        sortOrder: {
            name: 'sortOrder',
            label: 'Orden *',
            requiredErrorMsg: 'El orden es requerido.'
        }
    }
};
